<template>
    <header class="header container">
        <section class="header-left">
            <img src="../../assets/logo.png" class="logo">
            <div class="logo-title">上海医健卫生事务服务中心</div>
        </section>
        <!-- <section class="header-right">
            <input v-model="keyword" type="text" placeholder="请输入搜索内容" />
            <router-link :to="{name: 'list', query: {tag: 'search-result', keyword: keyword}}">
                <img src="../../assets/search.png" class="search">
            </router-link>
        </section> -->
    </header>
</template>

<script>
    export default {
        data() {
            return {
                keyword: ''
            }
        }
    }
</script>

<style>
    .logo {
        width: 8rem;
        height: 8rem;
        margin-top: 5.375rem;
    }
    
    .header {
        height: 18.375rem;
        background-image: url('../../assets/header.png');
        background-size: 100% 100%;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
    }

    .header-left {
        display: flex;
    }

    .header-right {
        margin-top: 7.0625rem;
        position: relative;
    }

    .header-right input {
        border: 1px solid #BD1A2D;
        width: 21.75rem;
        height: 2.125rem;
        border-radius: 4px;
    }

    .logo-title {
        font-size: 2.3125rem;
        font-weight: bold;
        color: #BD1A2D;
        font-family: Adobe Heiti Std;
        margin-top: 9.125rem;
        margin-left: 2.75rem;
    }

    .search {
        width: 2rem;
        height: 2rem;
        position: absolute;
        right: 0.625rem;
        top: 0.1875rem;
        cursor: pointer;
    }
</style>
